"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textFieldOverrides = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _base = require("@mui/base");
var _utils = require("@mui/utils");
var _styles = require("@mui/material/styles");
var _TextField = require("@mui/material/TextField");
var _InputLabel = _interopRequireDefault(require("@mui/material/InputLabel"));
var _FormControl = _interopRequireWildcard(require("@mui/material/FormControl"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _dist = require("@aaa-ncnu-ie/icons/dist");
var _Input = _interopRequireDefault(require("./Input"));
var _excluded = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "optional", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var textFieldOverrides = {
  MuiTextField: {
    styleOverrides: {
      root: function root(_ref) {
        var variant = _ref.ownerState.variant,
          _ref$theme = _ref.theme,
          palette = _ref$theme.palette,
          spacing = _ref$theme.spacing,
          typography = _ref$theme.typography;
        return {
          // .MuiTextField-root
          '.MuiInputBase-root': _objectSpread(_objectSpread({
            willChange: 'transform',
            '&:not(.Mui-error)': {
              color: palette.common.black
            },
            '&.Mui-error': {
              color: palette.error.dark
            }
          }, variant === 'outlined' && {
            '&:not(.Mui-error)': {
              '&:not(.Mui-disabled)': {
                '&:hover': {
                  boxShadow: palette.action.selectableHoverOutline
                },
                '&.Mui-focused': {
                  boxShadow: palette.action.focusOutline
                }
              }
            },
            '&:not(.Mui-disabled)': {
              boxShadow: palette.action.defaultOutline,
              '&.Mui-focused, &.Mui-error': {
                boxShadow: palette.action.focusOutline
              }
            }
          }), variant === 'filled' && {
            background: palette.common.white,
            boxShadow: palette.action.defaultUnderline,
            '&:not(.Mui-disabled)': {
              '&:not(.Mui-error)': {
                '&:hover': {
                  boxShadow: palette.action.selectableHoverUnderline
                }
              },
              '&.Mui-focused, &.Mui-error': {
                boxShadow: palette.action.focusUnderline,
                '&:hover': {
                  boxShadow: palette.action.focusUnderline
                }
              }
            },
            '&.Mui-disabled': {
              background: palette.action.disabledBackground,
              boxShadow: palette.action.disabledUnderline
            },
            '&.MuiInputBase-adornedStart': {
              'div.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)': {
                marginTop: spacing(0)
              }
            }
          }),
          '& .MuiFormHelperText-root': _objectSpread(_objectSpread({}, typography.footnote), {}, {
            color: palette.grey[600],
            marginLeft: spacing(2),
            marginTop: spacing(0.5),
            '&.Mui-error': {
              display: 'flex',
              color: palette.error.dark,
              '.MuiSvgIcon-root': {
                marginRight: spacing(1)
              }
            },
            '&.Mui-disabled': {
              color: palette.text.disabled
            }
          })
        };
      }
    }
  },
  MuiInputLabel: {
    styleOverrides: {
      root: function root(_ref2) {
        var ownerState = _ref2.ownerState,
          _ref2$theme = _ref2.theme,
          breakpoints = _ref2$theme.breakpoints,
          spacing = _ref2$theme.spacing,
          palette = _ref2$theme.palette,
          transitions = _ref2$theme.transitions,
          typography = _ref2$theme.typography;
        // .MuiInputLabel-root
        var _ref3 = ownerState.formControl,
          adornedStart = _ref3.adornedStart;
        return _objectSpread(_objectSpread(_objectSpread({}, typography.bodyLarge), {}, _defineProperty({
          zIndex: 1,
          overflow: 'visible',
          transform: "translate(".concat(spacing(2), ", ").concat(spacing(1.5), ")"),
          color: palette.grey[700],
          transition: transitions.create(['color', 'transform', 'max-width', 'font-size', 'font-weight'], {
            duration: transitions.duration.shorter,
            easing: transitions.easing.easeOut
          })
        }, breakpoints.up('tablet'), _objectSpread(_objectSpread({}, typography.bodyLarge), {}, {
          transform: 'translate(16px, 17px)'
        })), adornedStart && _defineProperty({
          transform: 'translate(48px, 12px)'
        }, breakpoints.up('tablet'), _objectSpread(_objectSpread({}, typography.bodyLarge), {}, {
          transform: "translate(48px, 17px)"
        }))), {}, {
          '&.Mui-focused': {
            color: palette.grey[700]
          },
          '&.Mui-error': {
            color: palette.grey[700]
          },
          '&.Mui-disabled': {
            color: palette.action.disabled
          },
          '&:not(.Mui-disabled)': {
            '.MuiInputLabel-suffix': {
              color: palette.grey[600]
            }
          },
          '&.MuiInputLabel-shrink': _objectSpread(_objectSpread(_objectSpread({}, typography.labelBold), {}, _defineProperty({
            transform: "translate(".concat(spacing(2), ", ").concat(spacing(0.5), ")")
          }, breakpoints.up('tablet'), _objectSpread(_objectSpread({}, typography.labelBold), {}, {
            transform: "translate(".concat(spacing(2), ", ").concat(spacing(1), ")")
          })), adornedStart && _defineProperty({
            transform: 'translate(48px, 4px)'
          }, breakpoints.up('tablet'), _objectSpread(_objectSpread({}, typography.labelBold), {}, {
            transform: "translate(48px, ".concat(spacing(1), ")")
          }))), {}, {
            '& + .MuiInputBase-root .MuiInputBase-input': _defineProperty({
              paddingTop: spacing(2.5),
              paddingBottom: spacing(0.5)
            }, breakpoints.up('tablet'), {
              paddingTop: spacing(3),
              paddingBottom: spacing(1)
            })
          })
        });
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      root: function root(_ref6) {
        var _ref6$theme = _ref6.theme,
          breakpoints = _ref6$theme.breakpoints,
          palette = _ref6$theme.palette,
          spacing = _ref6$theme.spacing,
          transitions = _ref6$theme.transitions,
          typography = _ref6$theme.typography;
        return _objectSpread(_objectSpread({}, typography.bodyLarge), {}, {
          borderRadius: '4px',
          transition: transitions.create(['box-shadow'], {
            duration: transitions.duration.shortest,
            easing: transitions.easing.sharp
          }),
          '&:not(.Mui-disabled)': {
            '.MuiInputBase-input': {
              color: palette.grey['600']
            },
            '.MuiInputAdornment-root': {
              color: palette.grey['600'],
              '.MuiIconButton-root': {
                color: palette.grey['600'],
                '&[aria-label="clear text field"]': {
                  color: palette.common.black
                }
              }
            }
          },
          '&.Mui-disabled': {
            background: palette.action.disabledBackground,
            '.MuiInputBase-input': {
              textFillColor: palette.action.disabled
            },
            '.MuiInputAdornment-root, .MuiIconButton-root': {
              color: palette.action.disabled
            }
          },
          '&.Mui-focused': {
            '.MuiInputBase-input': _defineProperty({
              paddingTop: spacing(2.5),
              paddingBottom: spacing(0.5)
            }, breakpoints.up('tablet'), {
              paddingTop: spacing(3),
              paddingBottom: spacing(1)
            })
          },
          '&.MuiInputBase-adornedEnd': {
            paddingRight: spacing(2),
            '.MuiInputBase-input': {
              paddingRight: spacing(0)
            },
            '.MuiIconButton-root': {
              marginRight: '-8px'
            }
          },
          '&.MuiInputBase-adornedStart': {
            paddingLeft: spacing(2),
            '.MuiInputBase-input': {
              paddingLeft: spacing(0)
            },
            '.MuiIconButton-root': {
              marginLeft: '-8px'
            }
          },
          '.MuiInputBase-input': _defineProperty({
            padding: "".concat(spacing(1.5), " ").concat(spacing(2))
          }, breakpoints.up('tablet'), {
            padding: spacing(2)
          })
        });
      }
    }
  }
};
exports.textFieldOverrides = textFieldOverrides;
var variantComponent = {
  filled: _Input.default,
  outlined: _Input.default
};
var useUtilityClasses = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes;
  var slots = {
    root: ['root']
  };
  return (0, _base.unstable_composeClasses)(slots, _TextField.getTextFieldUtilityClass, classes);
};
var FormControlState = function FormControlState(_ref7) {
  var children = _ref7.children;
  var muiFormControl = (0, _FormControl.useFormControl)();
  return children(muiFormControl);
};
var TextFieldRoot = (0, _styles.styled)(_FormControl.default, {
  name: 'MuiTextField',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    return styles.root;
  }
})({});
var TextField = /*#__PURE__*/_react.default.forwardRef(function TextField(inProps, ref) {
  var props = (0, _styles.useThemeProps)({
    props: inProps,
    name: 'MuiTextField'
  });
  var autoComplete = props.autoComplete,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    children = props.children,
    className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'primary' : _props$color,
    defaultValue = props.defaultValue,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$error = props.error,
    error = _props$error === void 0 ? false : _props$error,
    FormHelperTextProps = props.FormHelperTextProps,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
    helperText = props.helperText,
    idOverride = props.id,
    InputLabelProps = props.InputLabelProps,
    inputProps = props.inputProps,
    InputProps = props.InputProps,
    inputRef = props.inputRef,
    label = props.label,
    maxRows = props.maxRows,
    minRows = props.minRows,
    _props$multiline = props.multiline,
    multiline = _props$multiline === void 0 ? false : _props$multiline,
    name = props.name,
    onBlur = props.onBlur,
    onChange = props.onChange,
    onFocus = props.onFocus,
    optional = props.optional,
    placeholder = props.placeholder,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    rows = props.rows,
    _props$select = props.select,
    select = _props$select === void 0 ? false : _props$select,
    SelectProps = props.SelectProps,
    type = props.type,
    value = props.value,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'outlined' : _props$variant,
    other = _objectWithoutProperties(props, _excluded);
  var ownerState = _objectSpread(_objectSpread({}, props), {}, {
    autoFocus: autoFocus,
    color: color,
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    multiline: multiline,
    required: required,
    select: select,
    variant: variant
  });
  var textFieldRef = (0, _react.useRef)(null);
  (0, _react.useImperativeHandle)(ref, function () {
    return textFieldRef.current;
  });
  var classes = useUtilityClasses(ownerState);

  // eslint-disable-next-line turbo/no-undeclared-env-vars
  if (process.env.NODE_ENV !== 'production') {
    if (select && !children) {
      console.error('MUI: `children` must be passed when using the `TextField` component with `select`.');
    }
  }
  var InputMore = {};
  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }
    InputMore['aria-describedby'] = undefined;
    InputMore.endAdornment = null;
  }
  var id = (0, _utils.unstable_useId)(idOverride);
  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
  var InputComponent = variantComponent[variant];
  var InputElement = /*#__PURE__*/_react.default.createElement(InputComponent, _extends({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    maxRows: maxRows,
    minRows: minRows,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));
  return /*#__PURE__*/_react.default.createElement(TextFieldRoot, _extends({
    className: (0, _clsx.default)(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    ref: textFieldRef,
    required: required,
    color: color,
    variant: variant,
    ownerState: ownerState
  }, other), /*#__PURE__*/_react.default.createElement(FormControlState, null, function (_ref8) {
    var _SelectProps$MenuProp, _textFieldRef$current, _SelectProps$MenuProp2, _SelectProps$MenuProp3;
    var filled = _ref8.filled,
      focused = _ref8.focused;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label != null && label !== '' && /*#__PURE__*/_react.default.createElement(_InputLabel.default, _extends({
      htmlFor: id,
      id: inputLabelId,
      shrink: filled || focused
    }, InputLabelProps), label, optional && /*#__PURE__*/_react.default.createElement(_Typography.default, {
      className: "MuiInputLabel-suffix",
      variant: "option"
    }, ' ', "Optional")), select ? /*#__PURE__*/_react.default.createElement(_Select.default, _extends({
      "aria-describedby": helperTextId,
      id: id,
      labelId: inputLabelId,
      value: value,
      input: InputElement,
      IconComponent: function IconComponent(props) {
        return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
          component: _dist.TwoToneChevronDownSquare
        }, props));
      }
    }, SelectProps, {
      MenuProps: _objectSpread(_objectSpread({
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'right'
        }
      }, SelectProps === null || SelectProps === void 0 ? void 0 : SelectProps.MenuProps), {}, {
        PaperProps: _objectSpread(_objectSpread({}, SelectProps === null || SelectProps === void 0 ? void 0 : (_SelectProps$MenuProp = SelectProps.MenuProps) === null || _SelectProps$MenuProp === void 0 ? void 0 : _SelectProps$MenuProp.PaperProps), {}, {
          style: _objectSpread({
            minWidth: textFieldRef === null || textFieldRef === void 0 ? void 0 : (_textFieldRef$current = textFieldRef.current) === null || _textFieldRef$current === void 0 ? void 0 : _textFieldRef$current.clientWidth
          }, (SelectProps === null || SelectProps === void 0 ? void 0 : (_SelectProps$MenuProp2 = SelectProps.MenuProps) === null || _SelectProps$MenuProp2 === void 0 ? void 0 : _SelectProps$MenuProp2.PaperProps) != null ? SelectProps === null || SelectProps === void 0 ? void 0 : (_SelectProps$MenuProp3 = SelectProps.MenuProps) === null || _SelectProps$MenuProp3 === void 0 ? void 0 : _SelectProps$MenuProp3.PaperProps.style : null)
        })
      })
    }), children) : InputElement, helperText && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, _extends({
      id: helperTextId
    }, FormHelperTextProps), error && /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
      component: _dist.FillWarning
    }), helperText));
  }));
});
var _default = TextField;
exports.default = _default;